import { useRef } from "react";
import { Dialog } from "@headlessui/react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ReactToPrint from "react-to-print";

import IconClose from "assets/svg/close.svg";

import styles from "./styles.module.css";

const Modal = ({
  isOpen,
  handleClose,
  children,
  title,
  printButton,
  onlyCloseClickedButton = false,
  removeHeader,
  zIndex,
  isResponsive = false,
  ...options
}) => {
  const childrenRef = useRef();
  const innerRef = useRef();

  const onCloseFunction = () => (onlyCloseClickedButton ? () => {} : () => handleClose(false));

  const inner = classNames({
    [styles.inner]: true,
    [styles.responsiveInner]: isResponsive,
  });

  return (
    <>
      <Dialog open={isOpen} onClose={onCloseFunction()} className={styles.wrapper} style={{ zIndex }} {...options}>
        <Dialog.Panel className={inner} ref={innerRef}>
          {!removeHeader && (
            <div className={styles.close} onClick={() => handleClose(false)}>
              <IconClose />
            </div>
          )}
          <div className={styles.header}>
            {printButton && (
              <ReactToPrint
                trigger={() => <div className={styles.print}>Yazdır</div>}
                content={() => childrenRef.current}
              />
            )}
            {title && <Dialog.Title className={styles.title}>{title}</Dialog.Title>}
          </div>
          <div className={styles.content}>{children}</div>
        </Dialog.Panel>
      </Dialog>
    </>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.any,
  title: PropTypes.string,
  printButton: PropTypes.bool,
  onlyCloseClickedButton: PropTypes.bool,
  removeHeader: PropTypes.bool,
  zIndex: PropTypes.number,
  isResponsive: PropTypes.bool,
};

export default Modal;
